export default "__VITE_ASSET__CyY8oRKE__"